import { amsStoreSnapshot } from '../ams/ams.repository';

const BRAZE_SURVERY_STYLE_TAG = `<style type="text/css">
  .bz-modal {
    background-color: ${amsStoreSnapshot().theme === 'light' ? '#ffffff' : '#171c1e'} !important;
    color: ${amsStoreSnapshot().theme === 'light' ? '#252a2e' : '#ffffff'} !important;
  }
</style>`;

/**
 * Only use this for braze HTMLMessage type inAppMessages. This convoluted fix is necessary because
 * these types of messages are inserted in an iframe by braze. So we have to inject the styles this
 * way.
 * @param message An HTML document
 * @returns An HTML document with a style tag inserted for dark mode styles
 */
export const insertBrazeSurveyStyleTag = (message: string) => {
  if (!message.includes('<head>')) {
    return message;
  }

  const HEAD_TAG = '<head>';

  const indexToInsertAt = message.indexOf(HEAD_TAG) + HEAD_TAG.length;

  const newMessage =
    message.slice(0, indexToInsertAt) +
    BRAZE_SURVERY_STYLE_TAG +
    message.slice(indexToInsertAt);

  return newMessage;
};
